import { GET_PARTICULAR_OWNER_FAIL } from "store/owner/actionType";
import {
  ADD_TRANSACTION,
  ADD_TRANSACTION_FAIL,
  ADD_TRANSACTION_SUCCESS,
  GET_ALL_TRANSACTION,
  GET_ALL_TRANSACTION_SUCCESS,
  ADD_PHYSICAL_TRANSACTION,
  ADD_PHYSICAL_TRANSACTION_SUCCESS,
  ADD_PHYSICAL_TRANSACTION_FAIL,
  GET_ALL_TRANSATIONS_FROM_USER_ID,
  GET_ALL_TRANSATIONS_FROM_USER_ID_FAIL,
  GET_ALL_TRANSATIONS_FROM_USER_ID_SUCCESS,
  GET_PARTICULAR_TRANSACTION,
  GET_PARTICULAR_TRANSACTION_FAIL,
  GET_PARTICULAR_TRANSACTION_SUCCESS,
  GET_USER_EARNING_FROM_USER_ID,
  GET_USER_EARNING_FROM_USER_ID_FAIL,
  GET_USER_EARNING_FROM_USER_ID_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  error: "",
  loading: false,
  transaction: {},
  transactions: [],
  transactionsFromUserID: [],
  userEarning: 0,
  physicalTransactionResult: null,
};

const Transactions = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PARTICULAR_TRANSACTION:
    case GET_ALL_TRANSATIONS_FROM_USER_ID:
      return {
        ...state,
        loading: true,
      };

    case GET_PARTICULAR_TRANSACTION_SUCCESS:
      return {
        ...state,
        loading: false,
        transaction: action.payload.data || {},
      };

    case GET_PARTICULAR_OWNER_FAIL:
    case GET_ALL_TRANSATIONS_FROM_USER_ID_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case GET_ALL_TRANSACTION:
      return {
        ...state,
        loading: true,
      };

    case GET_ALL_TRANSACTION_SUCCESS:
      return {
        ...state,
        loading: false,
        transactions: action.payload.data || [],
      };

    case GET_PARTICULAR_TRANSACTION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ADD_TRANSACTION:
      return {
        ...state,
        loading: true,
      };

    case ADD_TRANSACTION_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case ADD_TRANSACTION_FAIL:

    case ADD_PHYSICAL_TRANSACTION:
      return {
        ...state,
        loading: true,
      };

    case ADD_PHYSICAL_TRANSACTION_SUCCESS:
      return {
        ...state,
        loading: false,
        physicalTransactionResult: action.payload || null,
      };

    case ADD_PHYSICAL_TRANSACTION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case GET_USER_EARNING_FROM_USER_ID_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case GET_ALL_TRANSATIONS_FROM_USER_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        transactionsFromUserID: action.payload.data || [],
      };

    case GET_USER_EARNING_FROM_USER_ID:
      return {
        ...state,
        loading: true,
      };

    case GET_USER_EARNING_FROM_USER_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        userEarning: action.payload.data || {},
      };

    default:
      return state;
  }
};

export default Transactions;
